import React from 'react';
import { HelpCircle, Mail, MessageSquare, ExternalLink } from 'lucide-react';

export default function SuperAdminSupport() {
  return (
    <div>
      <div className="sa-card" style={{ marginBottom: 16 }}>
        <div className="sa-card-body" style={{ textAlign: 'center', padding: 60 }}>
          <HelpCircle size={48} style={{ color: '#cbd5e1', margin: '0 auto 16px', display: 'block' }} />
          <h3 style={{ margin: '0 0 8px', fontSize: 18, color: '#1e293b' }}>Platform Support</h3>
          <p style={{ margin: '0 0 24px', fontSize: 13, color: '#64748b', maxWidth: 400, marginInline: 'auto' }}>
            Manage support tickets, customer inquiries, and account issues from this panel.
          </p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <div style={{ padding: 16, border: '1px solid #e2e8f0', borderRadius: 8, width: 180, textAlign: 'left' }}>
              <Mail size={20} style={{ color: '#3b82f6', marginBottom: 8 }} />
              <h4 style={{ margin: '0 0 4px', fontSize: 13, fontWeight: 700 }}>Email Support</h4>
              <p style={{ margin: 0, fontSize: 11, color: '#64748b' }}>support@ledgerpro.com</p>
            </div>
            <div style={{ padding: 16, border: '1px solid #e2e8f0', borderRadius: 8, width: 180, textAlign: 'left' }}>
              <MessageSquare size={20} style={{ color: '#16a34a', marginBottom: 8 }} />
              <h4 style={{ margin: '0 0 4px', fontSize: 13, fontWeight: 700 }}>Live Chat</h4>
              <p style={{ margin: 0, fontSize: 11, color: '#64748b' }}>Available 9-5 EST</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
